import { render, staticRenderFns } from "./KufanghuikuByIdForm.vue?vue&type=template&id=be1aca62&scoped=true&"
import script from "./KufanghuikuByIdForm.vue?vue&type=script&lang=js&"
export * from "./KufanghuikuByIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1aca62",
  null
  
)

export default component.exports